import { openBlock as o, createElementBlock as i, renderSlot as l, createCommentVNode as a, createElementVNode as n, toDisplayString as s, normalizeClass as r } from "vue";
import { themeProp as c } from "../../composables/useTheme.js";
const m = { class: "ds-display-flex ds-flex-direction-column" }, d = ["src", "alt"], u = {
  class: "ds-text-small ds-color-green ds-margin-bottom-3",
  "data-j-title": ""
}, g = ["src", "alt"], f = "DsFigureElement", y = /* @__PURE__ */ Object.assign({
  name: f
}, {
  __name: "figure-element",
  props: {
    ...c,
    /**
     * Caption Title
     */
    captionTitle: { type: String, required: !0 },
    /**
     * Caption text
     */
    captionText: { type: String, required: !0 },
    /**
     * Position of caption in relation the figure
     */
    captionPosition: {
      type: String,
      default: "bottom",
      validator: (t) => ["bottom", "top"].includes(t)
    },
    /**
     * Image
     * @property {Object} image.small - { src: String, name: String }
     * @property {Object} image.medium - { src: String, name: String }
     * @property {Object} image.large - { src: String, name: String }
     */
    image: {
      type: Object,
      default: null,
      validator: (t) => ["src", "name"].every((e) => e in t)
    }
  },
  setup(t) {
    return (e, p) => (o(), i("figure", m, [
      t.captionPosition === "bottom" ? l(e.$slots, "default", { key: 0 }, () => [
        t.image ? (o(), i("img", {
          key: 0,
          src: t.image.src,
          alt: t.image.name,
          class: "ds-margin-bottom-24",
          "data-j-figure-top": ""
        }, null, 8, d)) : a("", !0)
      ]) : a("", !0),
      n("figcaption", null, [
        n("p", u, s(t.captionTitle), 1),
        n("p", {
          class: r(["ds-text-small", [e.theme === "dark" ? "ds-color-white" : "ds-color-grey-1900"]]),
          "data-j-text": ""
        }, s(t.captionText), 3)
      ]),
      t.captionPosition === "top" ? l(e.$slots, "default", { key: 1 }, () => [
        t.image ? (o(), i("img", {
          key: 0,
          src: t.image.src,
          alt: t.image.name,
          class: "ds-margin-top-24",
          "data-j-figure-bottom": ""
        }, null, 8, g)) : a("", !0)
      ]) : a("", !0)
    ]));
  }
}), k = y;
export {
  k as default
};
